<div class="import-tms-load-list-container" *ngIf="nbRows > 0">
    <div class="import-tms-load-lists-icon-container">
        <div class="import-tms-load-lists-icon">
            <i class="fa fa-plus" *ngIf="type === ImportTmsLoadType.CREATION"></i>
            <i class="fa fa-pencil-alt" *ngIf="type === ImportTmsLoadType.UPDATE"></i>
            <i class="fa fa-trash-alt" *ngIf="type === ImportTmsLoadType.REMOVAL"></i>
        </div>
    </div>

    <div class="import-tms-load-lists">
        <div *ngIf="successes.length > 0" class="import-tms-load-list successes" [ngClass]="nbRows > 1 ? 'multi-lines' : ''">
            <div class="import-tms-load-list-header" (click)="toggleSuccesses()">

                <span class="import-tms-load-list-count">{{ successes.length }}</span>

                <span *ngIf="type === ImportTmsLoadType.CREATION" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.results.creation.count-successes'}]"></span>
                <span *ngIf="type === ImportTmsLoadType.UPDATE" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.results.update.count-successes'}]"></span>
                <span *ngIf="type === ImportTmsLoadType.REMOVAL" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.results.removal.count-successes'}]"></span>

                <div class="import-tms-load-list-expand">
                    <i class="fa" [ngClass]="showSuccesses ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                </div>
            </div>

            <ng-container *ngIf="showSuccesses">
                <div class="import-tms-load-list-content" *ngFor="let loadResult of successes">
                    <app-tms-import-load-result [result]="loadResult"></app-tms-import-load-result>
                </div>
            </ng-container>
        </div>

        <div *ngIf="failures.length > 0" class="import-tms-load-list failures" [ngClass]="nbRows > 1 ? 'multi-lines' : ''">
            <div class="import-tms-load-list-header" (click)="toggleFailures()">
                <span class="import-tms-load-list-count">{{ failures.length }}</span>

                <span *ngIf="type === ImportTmsLoadType.CREATION" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.results.creation.count-failures'}]"></span>
                <span *ngIf="type === ImportTmsLoadType.UPDATE" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.results.update.count-failures'}]"></span>
                <span *ngIf="type === ImportTmsLoadType.REMOVAL" [i18n]="[{target: 'innerHTML', key: 'local-loads.import.tms.results.removal.count-failures'}]"></span>

                <div class="import-tms-load-list-expand">
                    <i class="fa" [ngClass]="showSuccesses ? 'fa-minus-circle' : 'fa-plus-circle'"></i>
                </div>
            </div>

            <ng-container *ngIf="showFailures">
                <div class="import-tms-load-list-content" *ngFor="let loadResult of failures">
                    <app-tms-import-load-result [result]="loadResult"></app-tms-import-load-result>
                </div>
            </ng-container>
        </div>
    </div>
</div>
